import { interactionModelActions } from './slice'

export const {
  addActivityGroup,
  removeActivityGroup,
  updateActivities,
  setGeolocation,
  getInteractionModel,
  setConfigToNewInteraction,
  setInitialConfiguration,
  setWorkflow,
  dismissInformationCard,
  dismissGeolocationRequest
} = interactionModelActions

export default interactionModelActions
